import React from "react";
import { Helmet } from "react-helmet-async";

export default function Yazi1() {
    return (
        <div>
            <Helmet>
                <title>
                    Sigorta Şirketine Karşı Maddi Tazminat Davası - Trafik Kazası Sonrası
                    Haklarınız
                </title>
                <meta
                    name="description"
                    content="Trafik kazasından sonraki maddi zararlarınızı sigorta şirketinden alamıyor musunuz? Sigorta şirketine karşı nasıl maddi tazminat davası açabileceğinizi bu makalede öğrenin."
                />
                <link rel="canonical" href="/" />
            </Helmet>

            <div className="sm:mx-96 mx-2 text-gray-700 font-light text-lg">
                trafiktazminathesapla.com, bir Trafik Tazminat Danışmanlık Hizmetleri A.Ş. projesidir. Trafik Tazminat Danışmanlık Hizmetleri A.Ş., müşterilerine daha iyi hizmet verebilmek amacıyla bazı kişisel bilgilerinizi (isim, e-posta, telefon vb.) sizlerden talep etmektedir. Trafik Tazminat Danışmanlık Hizmetleri A.Ş. sunucularında toplanan bu bilgiler, dönemsel bilgilendirme çalışmaları, müşteri profillerine yönelik özel danışmanlık faaliyetlerinin kurgulanması ve istenmeyen e-postaların iletilmemesine yönelik müşteri "sınıflandırma" çalışmalarında sadece Trafik Tazminat Danışmanlık Hizmetleri A.Ş. bünyesinde kullanılmaktadır.

                Trafiktazminathesapla.com, iletişim formlarından topladığı bilgileri, ilgili kişinin haberi ya da aksi bir talimatı olmaksızın üçüncü şahıslarla kesinlikle paylaşmamakta, faaliyet dışı hiçbir nedenle ticari amaçla kullanmamakta ve satmamaktadır.

                trafiktazminathesapla.com, e-posta adresleri ve üyelik formlarında talep edilen kişisel bilgilerin dışında, site kullanımı sırasında ziyaretçi hareket ve tercihlerini analiz ederek yorumlayabilir. Kişisel bilgi içermeyen bu istatistiksel veriler, ziyaretçilere daha özel ve etkili bir kullanıcı deneyimi sunmak amacıyla Trafik Tazminat Danışmanlık Hizmetleri A.Ş. iş ortaklarıyla paylaşılabilmektedir.

                Müşteri bilgileri, yalnızca resmi makamlarca usulüne uygun şekilde talep edilmesi ve yürürlükteki zorunlu yasal düzenlemeler gereği açıklanması gerektiğinde, müşteriye bilgi verilerek resmi makamlara iletilebilir.

                Kullanıcı tarafından sisteme girilen tüm bilgilere yalnızca Trafik Tazminat Danışmanlık Hizmetleri A.Ş. erişebilmekte olup, bu bilgiler sadece şirket bünyesinde kullanılmaktadır. Üçüncü kişilerin bu bilgilere erişmesi veya bunları değiştirmesi mümkün değildir. Ayrıca, Trafik Tazminat Danışmanlık Hizmetleri A.Ş. tarafından gönderilen e-postaların alt kısmında yer alan “Kampanya duyurularından haberdar olmak istemiyorsanız lütfen tıklayınız.” bağlantısı aracılığıyla e-posta listesinden kolayca çıkabilirsiniz.

                Trafik Tazminat Danışmanlık Hizmetleri A.Ş.’ye aşağıdaki iletişim bilgilerinden ulaşabilirsiniz:

                Adres: Trafik Tazminat Danışmanlık Hizmetleri A.Ş.
                Yıldız Mah. Bahar Cad. No: 17, Beşiktaş / İstanbul

                Telefon: 0216 526 34 65
            </div>
        </div>
    );
}
